import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { formatFileSize } from '../../utils/file-validation';
import { primaryButtonStyle } from '../../utils/sharedStyles';

const formatDateTime = (value) => {
  if (!value) return 'לא זמין';
  const date = new Date(value);
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const formatDate = (value) => (value ? formatDateTime(value).split(',')[0] : null);

// The "i" on a document: who wrote it and when, who uploaded it and when, and
// what file it is. Laid out like ProtocolDetailsDialog.
const DocumentDetailsDialog = ({ open, document, folderPath, onClose }) => {
  if (!document) return null;

  const rows = [
    ['שם', document.name],
    ['נכתב על ידי', document.author],
    ['תאריך המסמך', formatDate(document.documentDate)],
    ['קובץ', document.file?.originalName],
    ['גודל', document.file?.size ? formatFileSize(document.file.size) : null],
    ['תיקייה', folderPath],
    ['הועלה על ידי', document.uploadedByUserName || 'לא ידוע'],
    ['תאריך העלאה', formatDateTime(document.createdAt)],
  ];
  if (document.updatedAt && document.updatedAt !== document.createdAt) {
    rows.push(['עודכן לאחרונה', formatDateTime(document.updatedAt)]);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { borderRadius: '8px', padding: '16px', maxWidth: '500px', width: '100%' } }}
    >
      <DialogTitle style={{ textAlign: 'center', fontWeight: 'bold', color: '#103C6E' }}>
        פרטי מסמך
      </DialogTitle>
      <DialogContent>
        {rows.filter(([, value]) => value).map(([label, value]) => (
          <Typography key={label} gutterBottom style={{ wordBreak: 'break-word' }}>
            <span style={{ fontWeight: 'bold', color: '#103C6E' }}>{label}:</span> {value}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', padding: '16px' }}>
        <Button onClick={onClose} style={primaryButtonStyle}>אישור</Button>
      </DialogActions>
    </Dialog>
  );
};

DocumentDetailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  document: PropTypes.object,
  folderPath: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};
export default DocumentDetailsDialog;
